import { useForm } from "antd/lib/form/Form";
import { useAtom } from "jotai";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { LoggedInUser } from "../../state/CoreState";
import crypto from "crypto";
export function useLogin() {
  const [user, setUser] = useAtom(LoggedInUser);
  let navigate = useNavigate();
  const [form] = useForm();

  const onSubmit = (data: { email: string }) => {
    const shaEmail = crypto
      .createHash("sha1")
      .update(data.email.toLowerCase())
      .digest("hex");
    setUser({ email: data.email.toLowerCase(), shaEmail });
    navigate("/app");
  };

  useEffect(() => {
    if (user) {
      // Redirect if already logged in
      navigate("/app");
    }
  }, [user, navigate]);

  return {
    callbacks: { navigate, onSubmit },
    states: { form },
  };
}
